var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-status-form-success"},[_c('div',{staticClass:"modal-status-form-success__title",domProps:{"textContent":_vm._s('Форма успешно отправлена!')}}),_c('div',{staticClass:"modal-status-form-success__button"},[_c('ui-button',{on:{"click":_vm.close}},[_vm._v(" Закрыть ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }